import React from 'react';
import { injectIntl } from 'react-intl';
import JobAlertsForm from '@Components/JobAlertsForm';
// TODO: Update ReactLib repo and export Toast component (/src/index.js)
// Replace App Toast component with UI.Toast component
import Toast from '@Components/Toast';
import t from 'prop-types';

function JobAlertsSection({ intl, searchParams, baseUrl }) {
  return (
    <div id="job-alerts" data-testid="job-alerts">
      <div className={`banner secondary-search ${process.env.REACT_APP_COUNTRY === 'sph' ? 'bg-brand--gradient-orange' : 'bg-variant-brand-primary'}`}>
        <div className="banner__wrapper wrapper">
          <div className="banner__media media-block media-block--contain">
            <img
              src={`${process.env.REACT_APP_ASSETS_BASE_PATH}/${process.env.REACT_APP_BRAND_GUIDELINES === 'true' ? 'image/person_background_blue.svg' : 'image/staffing-people.svg'}`}
              width="403"
              height={process.env.REACT_APP_BRAND_GUIDELINES === 'true' ? '490' : '556'}
              alt={intl.formatMessage({ id: 'JobAlerts.Component.Illustration.Alt' })}
            />
          </div>
          <div className="banner__content content-block">
            <h2 className="content-block__title">
              {intl.formatMessage({ id: 'JobAlerts.Section.Title' })}
            </h2>
            <p className="content-block__description">
              {intl.formatMessage({ id: 'JobAlerts.Section.Description' })}
            </p>
            <JobAlertsForm
              baseUrl={baseUrl}
              searchParams={searchParams}
            />
          </div>
        </div>
      </div>
      <Toast message={intl.formatMessage({ id: 'JobAlerts.Toast' })} anchor="job-alert-subscribed" />
    </div>
  );
}

JobAlertsSection.propTypes = {
  /** Form action base url. */
  baseUrl: t.string.isRequired,
  searchParams: t.shape({
    occupation: t.string,
    region: t.string,
    city: t.string,
    salary: t.string,
  }),
};

JobAlertsSection.defaultProps = {
  searchParams: {
    occupation: '',
    region: '',
    city: '',
    salary: '',
  },
};

export default injectIntl(JobAlertsSection);
